import React from 'react'
import { RootMixin } from 'legacy/libs/baobab-react-mixins'

import createReactClass from 'create-react-class'

export default function treeAwareAppComponentFactory(Component, tree) {
  const TreeWrapper = createReactClass({
    displayName: 'TreeWrapper',

    mixins: [RootMixin],

    render() {
      return <Component {...this.props} />
    },
  })

  return createReactClass({
    displayName: 'Wrapper',

    render() {
      return <TreeWrapper tree={tree} {...this.props} />
    },
  })
}
